import { render } from "./BabylonScene.vue?vue&type=template&id=165339cb&scoped=true&ts=true"
import script from "./BabylonScene.vue?vue&type=script&lang=ts"
export * from "./BabylonScene.vue?vue&type=script&lang=ts"

import "./BabylonScene.vue?vue&type=style&index=0&id=165339cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165339cb"]])

export default __exports__